import { extractDigits } from "./cardList";
import { Luscinia, luscinia } from "./luscinia";
import { ChangeElement, ChangeType } from "./postValueChanged";
import { getEditGridPostValueChangeObject } from "./record";

luscinia.addEditGridRowUsingButton = async function (button, duplicateRow = false, rowData: object = null) {
    const editGridWrapper = $(button).closest(".editGrid-wrapper");
    await addEditGridRow(editGridWrapper, duplicateRow, rowData, button);
};

Luscinia.prototype.removeEditGridRow = function (row, triggerPostValueChange = true) {
    let editGrid = $(row).closest(".editGrid");
    const editGridRows = editGrid.nextAll();

    editGridRows.each(function () {
        if ($(this).hasClass("editGrid")) {

            // Use a regular expression to replace the numeric indices in the edit grid names
            const originalEditGridRowName = $(this).attr("data-property-prefix");
            const newEditGridName = originalEditGridRowName.replace(/-(\d+)/g, function (match, p1) {
                return "-" + (parseInt(p1) - 1);
            });
            $(this).attr("data-property-prefix", newEditGridName);

            $(this).find(":input").each(function () {
                const originalName = $(this).attr("name");
                if (!originalName) return;

                const originalId = $(this).attr("id");

                // Use a regular expression to replace the numeric indices in the field names and parameters
                const newName = originalName.replace(/-(\d+)-/g, function (match, p1) {
                    return "-" + (parseInt(p1) - 1) + "-";
                });
                const newId = originalId.replace(/-(\d+)-/g, function (match, p1) {
                    return "-" + (parseInt(p1) - 1) + "-";
                });

                $(this).attr("name", newName);
                $(this).attr("id", newId);
            })
        }
    });

    var rowName = editGrid.attr("data-property-prefix");
    const postValueChangeObject = getEditGridPostValueChangeObject(editGrid);
    editGrid[0].remove();
    if (triggerPostValueChange) {
        luscinia.executePostValueChange(luscinia.getActiveForm(), undefined, rowName, ChangeType.Delete, ChangeElement.EditGridRow, false, postValueChangeObject);
    }
};

Luscinia.prototype.duplicateEditGridRow = async function (button) {
    await luscinia.addEditGridRowUsingButton(button, true, null);
};

export async function addEditGridRow(editGridWrapper: JQuery<HTMLElement>, duplicateRow = false, rowData: object = null, button: HTMLElement = null, triggerPostValueChange: boolean = true) {
    const parameterFullName = editGridWrapper.data("parameter-fullname");
    const lastEditGrid = editGridWrapper.find(".editGrid").last();
    const propertyNamePrefixBase = editGridWrapper.attr("name");
    const formNamePrefix = editGridWrapper.closest("form").attr("id");
    const digit = duplicateRow ? extractDigits($(button).closest(".editGrid").attr("data-property-prefix")) + 1 : lastEditGrid.length > 0 ? extractDigits(lastEditGrid.attr("data-property-prefix")) + 1 : 0;
    const propertyNamePrefix = `${propertyNamePrefixBase}-${digit}`;
    await $.ajax({
        url: `/rendereditGrid/${parameterFullName}/${propertyNamePrefix}/${formNamePrefix}`,
        method: "POST",
        data: JSON.stringify(rowData),
        contentType: "application/json",
        success: (data) => {
            const editGridContainer = editGridWrapper.find(".editGrid-container");

            let currentEditGrid: JQuery<HTMLElement>;
            if (duplicateRow) {
                currentEditGrid = $(button).closest(".editGrid");
                currentEditGrid.after(data);
                const newEditGrid = currentEditGrid.next();
                const allEditGrids = newEditGrid.nextAll('.editGrid');

                allEditGrids.each(function () {
                    // Use a regular expression to replace the numeric indices in the edit grid names
                    const originalEditGridName = $(this).attr("data-property-prefix");
                    const newEditGridName = originalEditGridName.replace(/-(\d+)/g, function (match, p1) {
                        return "-" + (parseInt(p1) + 1);
                    });
                    $(this).attr("data-property-prefix", newEditGridName);

                    $(this).find(":input").each(function () {
                        const originalName = $(this).attr("name");
                        if (!originalName) return;

                        const originalId = $(this).attr("id");

                        // Use a regular expression to replace the numeric indices in the field names and parameters
                        const newName = originalName.replace(/-(\d+)-/g, function (match, p1) {
                            return "-" + (parseInt(p1) + 1) + "-";
                        });
                        const newId = originalId.replace(/-(\d+)-/g, function (match, p1) {
                            return "-" + (parseInt(p1) + 1) + "-";
                        });

                        $(this).attr("name", newName);
                        $(this).attr("id", newId);
                    });
                });


                luscinia.initFormElements(currentEditGrid.next(".editGrid"), editGridWrapper.closest("form")).then(function () {
                    var $sourceInputs = currentEditGrid.find('input');
                    var $destinationInputs = newEditGrid.find('input');

                    $sourceInputs.each(function (_, element) {
                        var sourceId = element.id;
                        var $destinationInput = $destinationInputs.filter('#' + sourceId);
                        if ($destinationInput.length > 0) {
                            luscinia.setValue(newEditGrid[0], $destinationInput[0].name, element.value);
                        }
                    });
                });

                currentEditGrid = newEditGrid;
            } else {
                editGridContainer.append(data);
                currentEditGrid = editGridContainer.find(".editGrid").last();
                luscinia.initFormElements(currentEditGrid, editGridWrapper.closest("form"));
            }

            const postValueChangeObject = getEditGridPostValueChangeObject(currentEditGrid);
            var rowName = currentEditGrid.attr("data-property-prefix");
            const changeType = duplicateRow ? ChangeType.Copy : ChangeType.Create;
            if (triggerPostValueChange) {
                luscinia.executePostValueChange(luscinia.getActiveForm(), undefined, rowName, changeType, ChangeElement.EditGridRow, false, postValueChangeObject);
            }
        }
    });
}

